import React from 'react';
import { formatCurrency } from '../../../lib/helpers/formatters';
import { useAuth } from '../../../commons/Auth';

const TotalTr = ({
  totals = {},
  route = '',
  activeRoute = false,
  truncateTotals = false,
  profileType = '',
}) => {
  const {
    netTotals = 0,
    grossTotals = 0,
    shareToInvoiceTotals = 0,
    panoramicaShareTotals = 0,
    adminShareTotals = 0,
    earnedAdminShareTotals = 0,
    billableAdminShareTotals = 0,
  } = totals;

  const [{ newIsAdmin }] = useAuth();

  return (
    <tr
      className="summary-tr"
      onClick={() => {
        return activeRoute === true
          ? (window.location.href = `${
              window.location.href.split('?')[0]
            }/${route}`)
          : null;
      }}
    >
      {!truncateTotals && newIsAdmin && <td>-</td>}
      {!truncateTotals && <td>-</td>}
      {!truncateTotals && <td>-</td>}
      {!truncateTotals && <td>-</td>}
      {!truncateTotals && <td>-</td>}
      {!truncateTotals && <td>-</td>}
      {!truncateTotals && <td>-</td>}
      {!truncateTotals && <td>-</td>}
      {!truncateTotals && <td>-</td>}
      {!truncateTotals && <td>-</td>}
      {!truncateTotals && <td>-</td>}
      {!truncateTotals && <td>-</td>}
      {!truncateTotals && <td>-</td>}
      {!truncateTotals && <td>-</td>}
      {!truncateTotals && <td>-</td>}
      {!truncateTotals && profileType === 'ASSOCIATION' && <td>-</td>}
      {!truncateTotals && profileType === 'ASSOCIATION' && <td>-</td>}
      {!truncateTotals && profileType === 'ASSOCIATION' && <td>-</td>}

      <td className="txt-table-right">{formatCurrency(grossTotals)}</td>
      <td className="txt-table-right">{formatCurrency(netTotals)}</td>
      <td className="txt-table-right">
        {formatCurrency(shareToInvoiceTotals)}
      </td>
      {!truncateTotals && <td>-</td>}
      <td className="txt-table-right">
        {formatCurrency(panoramicaShareTotals)}
      </td>
      {!truncateTotals && (
        <td className="txt-table-right">{formatCurrency(adminShareTotals)}</td>
      )}
      {!truncateTotals && newIsAdmin && <td>-</td>}
      <td className="txt-table-right">
        {formatCurrency(earnedAdminShareTotals)}
      </td>
      <td className="txt-table-right">
        {formatCurrency(billableAdminShareTotals)}
      </td>

      {!truncateTotals && <td>-</td>}
      {!truncateTotals && <td>-</td>}
    </tr>
  );
};

export default TotalTr;
